// Components==============
import Token from 'components/UI/Token/Token';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useEffect } from 'react';
import Button from 'components/UI/Button/Button';
import './OverviewCard.module.scss';
import { ReflectContext } from 'pages/Growth/Reflect/Reflect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { useHistory } from 'react-router';
import { GlobalReflectionContext } from 'utilities/GlobalContext/GlobalReflectionContext';
// =========================

export default function Card({
  activities,
}: {
  activities: ProcessProcessEntity[];
}) {
  const cardItem = activities.pop();

  const isEndPoint = cardItem?.process_type === 'App\\Phase';
  const {
    processGroups,
    isTeacher,
    project,
    endPointActivities,
    endPointActivity,
  } = useContext(ReflectContext);

  const { selectedReflection } = useContext(GlobalReflectionContext);
  const history = useHistory();

  useEffect(() => {
    if (isEndPoint && selectedReflection)
      history.push(`/groei/reflecteren/${project?.id}/${cardItem.id}`);
  }, []);

  const checkPointToken = useRedux((state) =>
    cardItem?.process_type === 'App\\Activity'
      ? state.activity?.entities.byId[cardItem?.process_id]
      : undefined
  );

  const endPointToken = useRedux((state) =>
    cardItem?.process_type === 'App\\Phase'
      ? state.phase?.entities.byId[cardItem?.process_id]
      : undefined
  );

  const getPhase = (processId: number) =>
    processGroups?.find((group) =>
      group.activities.find((a) => a.processId === processId)
    )?.phase;

  const translate = useTranslate();

  const conditionalActivities = isEndPoint ? endPointActivities : activities;

  const isFinished = useRedux((state) => {
    const reflections = state.reflection?.entities.allIds
      .map((id) => state.reflection?.entities.byId[id])
      .filter(
        (r) =>
          r?.created_by === state.authentication?.user?.id &&
          r?.project_process?.project_id === project?.id
      );

    const finishedActivities = conditionalActivities.map((a) => {
      const reflection = reflections?.find(
        (r) => r?.project_process?.process_id === a?.process_id
      );

      // doesn't exist
      if (!reflection) return false;
      // not finished and active
      if (!reflection.finished && reflection.contributed) return false;

      return true;
    });

    const endPointReflection = reflections?.find(
      (r) => r?.project_process?.process_id === endPointActivity?.process_id
    );

    const endPointIsFinished = endPointReflection
      ? endPointReflection?.note?.find((qna) => !qna.answer) === undefined
      : false;

    if (isEndPoint)
      return !finishedActivities.includes(false) && endPointIsFinished;

    return !finishedActivities.includes(false);
  });

  return (
    <div styleName={`wrapper ${isEndPoint ? 'end-point' : ''}`}>
      <Token token={checkPointToken || endPointToken} />
      <div styleName="activities">
        <p>
          {conditionalActivities?.length}{' '}
          {conditionalActivities && conditionalActivities?.length > 1
            ? translate('project.terms.activities')
            : translate('project.terms.activity')}
        </p>
        <div
          styleName="circles"
          style={{
            gridTemplateColumns: `repeat(${
              isEndPoint && conditionalActivities.length > 12
                ? 13
                : !isEndPoint && conditionalActivities.length > 7
                ? 8
                : conditionalActivities.length
            }, 1fr)`,
          }}
        >
          {conditionalActivities?.map(
            (a) =>
              !!a && <div key={a.id} styleName={`circle ${getPhase(a.id)}`} />
          )}
        </div>
      </div>
      {typeof cardItem?.description === 'string' && !!cardItem.description && (
        <div styleName="explanation">
          <strong>{translate('general.terms.explanation')}</strong>
          <p>{cardItem.description}</p>
        </div>
      )}
      <div styleName="divider" />
      <Button
        color={isFinished ? 'green' : 'grey'}
        to={`/groei/reflecteren/${project?.id}/${cardItem?.id}`}
      >
        {isFinished ? (
          <>
            {translate('reflection.terms.done')}{' '}
            <FontAwesomeIcon icon={faCheck} />
          </>
        ) : (
          <>
            {isTeacher
              ? isEndPoint
                ? translate('general.terms.end-judgement')
                : translate('general.terms.judge')
              : isEndPoint
              ? translate('general.terms.end-reflection')
              : translate('general.terms.reflect')}
          </>
        )}
      </Button>
    </div>
  );
}
